import { render, staticRenderFns } from "./DetailProfileRiskAml.vue?vue&type=template&id=9ebb7588"
import script from "./DetailProfileRiskAml.vue?vue&type=script&lang=js"
export * from "./DetailProfileRiskAml.vue?vue&type=script&lang=js"
import style0 from "./DetailProfileRiskAml.vue?vue&type=style&index=0&id=9ebb7588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports